import React from 'react';
import PropTypes from 'prop-types';

const BackToPG = ({ size, fill, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M2.45898 6.66663H9.12565C12.0712 6.66663 14.459 9.05444 14.459 12V13.3333M2.45898 6.66663L6.45898 10.6666M2.45898 6.66663L6.45898 2.66663"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

BackToPG.propTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
};

BackToPG.defaultProps = {
  size: 16,
  fill: '#096dd9',
};

export default BackToPG;



// WEBPACK FOOTER //
// ./src/client/Components/Icons/BackToPG.js